import { motion } from 'motion/react';

/** Stretching contact shadow while a ticket falls. */
export function GravityShadow() {
  return (
    <motion.div
      className="pointer-events-none absolute left-1/2 top-[92%] z-0 h-3 w-4/5 -translate-x-1/2 rounded-full bg-black/50 blur-md"
      variants={{
        rest: { opacity: 0, scaleX: 0.6, scaleY: 1 },
        dispose: {
          opacity: [0.35, 0.55, 0],
          scaleX: [0.8, 1.35, 1.7],
          scaleY: [1, 0.55, 0.3],
          y: [0, 12, 40],
          transition: { duration: 0.9, ease: 'easeIn' },
        },
      }}
    />
  );
}
